 
// rem等比适配配置文件
// 基准大小
const baseSize = 16

// 判断设备是移动端还是手机端
let flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
)
let baseNum= flag?375:1920
// 设置 rem 函数
function setRem () {
  // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
  const scale = document.documentElement.clientWidth / baseNum
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  if(flag){
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 1) + 'px'
  }else{
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
  }
  
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
}


// WEBPACK FOOTER //
// ./src/utils/rem.js